import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import { upcommingAppointments } from '../../redux/appointments/actions';
import moment from 'moment';

// @desc    Get all upcomming appointments
export const getAllUpcommingAppointments = async (callback) => {
	function ReturnScheduledAppointment(
		newKey,
		newTime,
		newEmail,
		newName,
		newNumber,
		shortCode
	) {
		console.log('ReturnScheduledAppointment ' + shortCode);
		var newAppointment = {
			appointmentId: newKey,
			appointmentTime: newTime,
			appointmentMainEmail: newEmail,
			appointmentMainName: newName,
			appointmentMainNumber: newNumber,
			appointmentShortCode: shortCode,
		};

		return newAppointment;
	}

	var currentUserId = firebase.auth().currentUser.uid;

	var appointmentsRef = firebase
		.database()
		.ref('/client_appointments/' + PROJECT_CODE.projectCode);
	appointmentsRef
		.orderByChild('createrID')
		.equalTo(currentUserId)
		.on('value', async (snapshot) => {
			var upcomingAppointments = [];
			console.log('appointments api snapshot', snapshot);
			snapshot.forEach((element) => {
				var elementTime = element.val().timeOfAppointment;
				let currentTimeDate = Date.now();
				var time30MinAgo = currentTimeDate - 1800000;

				var showClientUser = true;

				//null check
				if (
					element.val().createUser != null &&
					element.val().createUser !== undefined
				) {
					showClientUser = element.val().createUser;
				}

				if (elementTime > time30MinAgo && showClientUser === true) {
					var snapUser = element.child('users');
					var allChildren = [];
					snapUser.forEach((child) => {
						var childUser = {
							childEmail: child.val().email,
							childName: child.val().fullName,
							childNumber: child.val().phoneNumber,
						};
						allChildren.push(childUser);
					});

					console.log('appointments api All children: ', allChildren);
					var newAppointment = ReturnScheduledAppointment(
						element.key,
						elementTime,
						allChildren[0].childEmail,
						allChildren[0].childName,
						allChildren[0].childNumber,
						element.val().shortCode
					);

					upcomingAppointments.push(newAppointment);
				}
			});
			upcomingAppointments.sort(function (a, b) {
				return a.appointmentTime - b.appointmentTime;
			});

			callback(upcomingAppointments);
		});
};

// @desc    Get all past appointments
export const getAllPastAppointments = (callback) => {
	function ReturnScheduledAppointment(
		newKey,
		newTime,
		newEmail,
		newName,
		newNumber,
		shortCode
	) {
		console.log('ReturnScheduledAppointment ' + shortCode);
		var newAppointment = {
			appointmentId: newKey,
			appointmentTime: newTime,
			appointmentMainEmail: newEmail,
			appointmentMainName: newName,
			appointmentMainNumber: newNumber,
			appointmentShortCode: shortCode,
		};

		return newAppointment;
	}
	var currentUserId = firebase.auth().currentUser.uid;
	var appointmentsRef = firebase
		.database()
		.ref('/client_appointments/' + PROJECT_CODE.projectCode);
	appointmentsRef
		.orderByChild('createrID')
		.equalTo(currentUserId)
		.on('value', async (snapshot) => {
			var pastAppointments = [];

			snapshot.forEach((element) => {
				var elementTime = element.val().timeOfAppointment;
				let currentTimeDate = Date.now();
				var time30MinAgo = currentTimeDate - 1800000;

				var showClientUser = true;

				//null check
				if (
					element.val().createUser != null &&
					element.val().createUser !== undefined
				) {
					showClientUser = element.val().createUser;
				}

				if (!(elementTime > time30MinAgo && showClientUser === true)) {
					var showClientUser = true;

					//null check
					if (
						element.val().createUser != null &&
						element.val().createUser !== undefined
					) {
						showClientUser = element.val().createUser;
					}

					if (showClientUser === true) {
						var snapUser = element.child('users');
						var allChildren = [];

						snapUser.forEach((child) => {
							var childUser = {
								childEmail: child.val().email,
								childName: child.val().fullName,
								childNumber: child.val().phoneNumber,
							};
							allChildren.push(childUser);
						});

						if (allChildren.length > 0) {
							var newAppointment = ReturnScheduledAppointment(
								element.key,
								elementTime,
								allChildren[0].childEmail,
								allChildren[0].childName,
								allChildren[0].childNumber,
								element.val().shortCode
							);
							pastAppointments.push(newAppointment);
						}
					}
				}
			});
			pastAppointments.sort(function (a, b) {
				return a.appointmentTime - b.appointmentTime;
			});

			await callback(pastAppointments);
		});
};

// @desc    Get all upcomming appointments by sales agent ID
export const getAllUpcommingAppointmentsBySalesAgentId = async (
	salesAgentId,
	filterByDate,
	callback
) => {
	function ReturnScheduledAppointment(
		newKey,
		newTime,
		newEmail,
		newName,
		newNumber,
		shortCode
	) {
		console.log('ReturnScheduledAppointment ' + shortCode);
		var newAppointment = {
			appointmentId: newKey,
			appointmentTime: newTime,
			appointmentMainEmail: newEmail,
			appointmentMainName: newName,
			appointmentMainNumber: newNumber,
			appointmentShortCode: shortCode,
		};

		return newAppointment;
	}

	var appointmentsRef = firebase
		.database()
		.ref('/client_appointments/' + PROJECT_CODE.projectCode);
	appointmentsRef
		.orderByChild('createrID')
		.equalTo(salesAgentId)
		.on('value', async (snapshot) => {
			var upcomingAppointments = [];
			console.log('appointments api snapshot', snapshot);
			snapshot.forEach((element) => {
				var elementTime = element.val().timeOfAppointment;
				let currentTimeDate = Date.now();
				var time30MinAgo = currentTimeDate - 1800000;

				var showClientUser = true;

				//null check
				if (
					element.val().createUser != null &&
					element.val().createUser !== undefined
				) {
					showClientUser = element.val().createUser;
				}

				// check appointment created timestamp
				let isAppointmentNotFiltered = true;
				if (element.val()?.createTimestamp) {
					if (filterByDate === 'All') {
						isAppointmentNotFiltered = true;
					} else if (filterByDate === 'Month') {
						isAppointmentNotFiltered = moment(
							element.val().createTimestamp
						).isBetween(moment().subtract(1, 'months'), moment());
					} else if (filterByDate === 'Week') {
						isAppointmentNotFiltered = moment(
							element.val().createTimestamp
						).isBetween(moment().subtract(7, 'days'), moment());
					} else if (filterByDate === 'Today') {
						isAppointmentNotFiltered = moment(
							element.val().createTimestamp
						).isBetween(moment().subtract(1, 'days'), moment());
					} else {
						isAppointmentNotFiltered = true;
					}
				}

				if (
					elementTime > time30MinAgo &&
					showClientUser === true &&
					isAppointmentNotFiltered === true
				) {
					var snapUser = element.child('users');
					var allChildren = [];
					snapUser.forEach((child) => {
						var childUser = {
							childEmail: child.val().email,
							childName: child.val().fullName,
							childNumber: child.val().phoneNumber,
						};
						allChildren.push(childUser);
					});

					console.log('appointments api All children: ', allChildren);
					var newAppointment = ReturnScheduledAppointment(
						element.key,
						elementTime,
						allChildren[0].childEmail,
						allChildren[0].childName,
						allChildren[0].childNumber,
						element.val().shortCode
					);

					upcomingAppointments.push(newAppointment);
				}
			});
			upcomingAppointments.sort(function (a, b) {
				return a.appointmentTime - b.appointmentTime;
			});

			callback(upcomingAppointments);
		});
};

// @desc    Get all past appointments by sales agent ID
export const getAllPastAppointmentsBySalesAgentId = (
	salesAgentId,
	callback
) => {
	function ReturnScheduledAppointment(
		newKey,
		newTime,
		newEmail,
		newName,
		newNumber,
		shortCode
	) {
		console.log('ReturnScheduledAppointment ' + shortCode);
		var newAppointment = {
			appointmentId: newKey,
			appointmentTime: newTime,
			appointmentMainEmail: newEmail,
			appointmentMainName: newName,
			appointmentMainNumber: newNumber,
			appointmentShortCode: shortCode,
		};

		return newAppointment;
	}
	var appointmentsRef = firebase
		.database()
		.ref('/client_appointments/' + PROJECT_CODE.projectCode);
	appointmentsRef
		.orderByChild('createrID')
		.equalTo(salesAgentId)
		.on('value', async (snapshot) => {
			var pastAppointments = [];

			snapshot.forEach((element) => {
				var elementTime = element.val().timeOfAppointment;
				let currentTimeDate = Date.now();
				var time30MinAgo = currentTimeDate - 1800000;

				var showClientUser = true;

				//null check
				if (
					element.val().createUser != null &&
					element.val().createUser !== undefined
				) {
					showClientUser = element.val().createUser;
				}

				if (!(elementTime > time30MinAgo && showClientUser === true)) {
					var showClientUser = true;

					//null check
					if (
						element.val().createUser != null &&
						element.val().createUser !== undefined
					) {
						showClientUser = element.val().createUser;
					}

					if (showClientUser === true) {
						var snapUser = element.child('users');
						var allChildren = [];

						snapUser.forEach((child) => {
							var childUser = {
								childEmail: child.val().email,
								childName: child.val().fullName,
								childNumber: child.val().phoneNumber,
							};
							allChildren.push(childUser);
						});

						if (allChildren.length > 0) {
							var newAppointment = ReturnScheduledAppointment(
								element.key,
								elementTime,
								allChildren[0].childEmail,
								allChildren[0].childName,
								allChildren[0].childNumber,
								element.val().shortCode
							);
							pastAppointments.push(newAppointment);
						}
					}
				}
			});
			pastAppointments.sort(function (a, b) {
				return a.appointmentTime - b.appointmentTime;
			});

			await callback(pastAppointments);
		});
};

export const getAllUpcommingAppointmentsForAllSalesAgent = async (
	filterByDate,
	callback
) => {
	function ReturnScheduledAppointment(
		newKey,
		newTime,
		newEmail,
		newName,
		newNumber,
		shortCode
	) {
		console.log('ReturnScheduledAppointment ' + shortCode);
		var newAppointment = {
			appointmentId: newKey,
			appointmentTime: newTime,
			appointmentMainEmail: newEmail,
			appointmentMainName: newName,
			appointmentMainNumber: newNumber,
			appointmentShortCode: shortCode,
		};

		return newAppointment;
	}

	firebase
		.database()
		.ref('/client_appointments/' + PROJECT_CODE.projectCode)
		.on('value', async (snapshot) => {
			let appointmentsParent = snapshot.val();
			if (appointmentsParent) {
				let appointmentsKey = Object.keys(appointmentsParent);
				let upcomingAppointments = [];
				appointmentsKey.forEach((key) => {
					let appointmentTime =
						appointmentsParent[key].timeOfAppointment;
					let currentTimeDate = Date.now();
					let time30MinAgo = currentTimeDate - 1800000;
					var showClientUser = true;
					//null check
					if (
						appointmentsParent[key].createUser != null &&
						appointmentsParent[key].createUser !== undefined
					) {
						showClientUser = appointmentsParent[key].createUser;
					}
					// check appointment created timestamp
					let isAppointmentNotFiltered = true;
					if (appointmentsParent[key]?.createTimestamp) {
						if (filterByDate === 'All') {
							isAppointmentNotFiltered = true;
						} else if (filterByDate === 'Month') {
							isAppointmentNotFiltered = moment(
								appointmentsParent[key].createTimestamp
							).isBetween(
								moment().subtract(1, 'months'),
								moment()
							);
						} else if (filterByDate === 'Week') {
							isAppointmentNotFiltered = moment(
								appointmentsParent[key].createTimestamp
							).isBetween(moment().subtract(7, 'days'), moment());
						} else if (filterByDate === 'Today') {
							isAppointmentNotFiltered = moment(
								appointmentsParent[key].createTimestamp
							).isBetween(moment().subtract(1, 'days'), moment());
						} else {
							isAppointmentNotFiltered = true;
						}
					}
					if (
						appointmentTime > time30MinAgo &&
						showClientUser === true &&
						isAppointmentNotFiltered === true
					) {
						var snapUser = appointmentsParent[key].users;
						var allChildren = [];
						snapUser.forEach((child) => {
							var childUser = {
								childEmail: child.email,
								childName: child.fullName,
								childNumber: child.phoneNumber,
							};
							allChildren.push(childUser);
						});

						console.log(
							'appointments api All children: ',
							allChildren
						);
						var newAppointment = ReturnScheduledAppointment(
							key,
							appointmentTime,
							allChildren[0].childEmail,
							allChildren[0].childName,
							allChildren[0].childNumber,
							appointmentsParent[key].shortCode
						);
						upcomingAppointments.push(newAppointment);
					}
				});
				upcomingAppointments.sort(function (a, b) {
					return a.appointmentTime - b.appointmentTime;
				});
				callback(upcomingAppointments);
			} else {
				callback([]);
			}
		});
};

export const getAllPastAppointmentsForAllSalesAgent = async (callback) => {
	function ReturnScheduledAppointment(
		newKey,
		newTime,
		newEmail,
		newName,
		newNumber,
		shortCode
	) {
		console.log('ReturnScheduledAppointment ' + shortCode);
		var newAppointment = {
			appointmentId: newKey,
			appointmentTime: newTime,
			appointmentMainEmail: newEmail,
			appointmentMainName: newName,
			appointmentMainNumber: newNumber,
			appointmentShortCode: shortCode,
		};

		return newAppointment;
	}
	firebase
		.database()
		.ref('/client_appointments/' + PROJECT_CODE.projectCode)
		.on('value', async (snapshot) => {
			let appointmentsParent = snapshot.val();
			if (appointmentsParent) {
				let appointmentsKey = Object.keys(appointmentsParent);
				var pastAppointments = [];
				appointmentsKey.forEach((key) => {
					let appointmentTime =
						appointmentsParent[key].timeOfAppointment;
					let currentTimeDate = Date.now();
					let time30MinAgo = currentTimeDate - 1800000;
					var showClientUser = true;

					//null check
					if (
						appointmentsParent[key].createUser != null &&
						appointmentsParent[key].createUser !== undefined
					) {
						showClientUser = appointmentsParent[key].createUser;
					}
					if (
						!(
							appointmentTime > time30MinAgo &&
							showClientUser === true
						)
					) {
						var showClientUser = true;
						//null check
						if (
							appointmentsParent[key].createUser != null &&
							appointmentsParent[key].createUser !== undefined
						) {
							showClientUser = appointmentsParent[key].createUser;
							if (showClientUser === true) {
								var snapUser = appointmentsParent[key].users;
								var allChildren = [];
								snapUser.forEach((child) => {
									var childUser = {
										childEmail: child.email,
										childName: child.fullName,
										childNumber: child.phoneNumber,
									};
									allChildren.push(childUser);
								});
								if (allChildren.length > 0) {
									var newAppointment =
										ReturnScheduledAppointment(
											key,
											appointmentTime,
											allChildren[0].childEmail,
											allChildren[0].childName,
											allChildren[0].childNumber,
											appointmentsParent[key].shortCode
										);
									pastAppointments.push(newAppointment);
								}
							}
						}
					}
				});
				pastAppointments.sort(function (a, b) {
					return a.appointmentTime - b.appointmentTime;
				});
				callback(pastAppointments);
			} else {
				callback([]);
			}
		});
};

export const scheduleAppointment = (appointment, setLoading, displayAlert) => {
	setLoading(true);
	appointment.projectCode = PROJECT_CODE.projectCode;
	firebase
		.database()
		.ref('/client_appointments/' + PROJECT_CODE.projectCode)
		.orderByChild('createrID')
		.equalTo(appointment.createrID)
		.once('value', (snapshot) => {
			let appointmentsParent = snapshot.val();
			if (appointmentsParent) {
				let appointmentsKeys = Object.keys(appointmentsParent);
				let filteredAppointmentKeys = appointmentsKeys.filter(
					(appointmentsKey) => {
						return (
							appointmentsParent[appointmentsKey].users['0']
								.email === appointment.users['0'].email
						);
					}
				);
				if (filteredAppointmentKeys.length === 0) {
					let createNewAppointment = firebase
						.functions()
						.httpsCallable('CreateMeetingFromData');
					createNewAppointment(appointment)
						.then((returned) => {
							displayAlert &&
								displayAlert(
									'Create appointment successfully.',
									'success'
								);
							console.log('returned 620', returned);
						})
						.catch(() => {
							displayAlert &&
								displayAlert(
									'Fail to create appointment.',
									'error'
								);
						})
						.finally(() => {
							setLoading && setLoading(false);
						});
				} else {
					setLoading && setLoading(false);
					displayAlert &&
						displayAlert(
							'Fail to create appointment. Try another email.',
							'error'
						);
				}
			} else {
				let createNewAppointment = firebase
					.functions()
					.httpsCallable('CreateMeetingFromData');
				createNewAppointment(appointment)
					.then((returned) => {
						displayAlert &&
							displayAlert(
								'Create appointment successfully.',
								'success'
							);

						console.log('returned 652', returned);
					})
					.catch(() => {
						displayAlert &&
							displayAlert(
								'Fail to create appointment.',
								'error'
							);
					})
					.finally(() => {
						setLoading && setLoading(false);
					});
			}
		});
};
